import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import {
  APPEND_ARGUMENTS,
  SPIN_CAR_VIEWER_CREATIVE_ID,
  SpinCarPhotoInfo,
} from 'site-modules/shared/constants/inventory/spin-car';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';

import './spin-car.scss';

const SPINNER_SIZE = 75;

export function SpinCar({ spinCarPhotoInfo, iframeClasses = '' }) {
  const iframeSrc = get(spinCarPhotoInfo, 'extIntUrl');
  const iframeUrl = `${iframeSrc}/?#!${APPEND_ARGUMENTS.join('!')}`;

  return (
    <div className="spin-car pos-r" data-tracking-parent={SPIN_CAR_VIEWER_CREATIVE_ID}>
      <div className="spinner-wrapper d-flex justify-content-center align-items-center bg-white w-100 h-100">
        <div>
          <Spinner color="primary" size={SPINNER_SIZE} />
        </div>
      </div>
      <iframe
        className={classNames('border-0 pos-a', iframeClasses)}
        title="Spin Car"
        scrolling="no"
        src={iframeUrl}
        height="100%"
        width="100%"
        sandbox="allow-scripts allow-same-origin"
      />
    </div>
  );
}

SpinCar.propTypes = {
  spinCarPhotoInfo: SpinCarPhotoInfo.isRequired,
  iframeClasses: PropTypes.string,
};
